export default __webpack_public_path__ + "static/media/up_not_ok.7fe9b4c5.svg";